import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as _ from 'underscore';
let CartLevel = class CartLevel extends Vue {
    constructor() {
        super(...arguments);
        this.show = false;
        this.spuInfo = {};
        this.skus = [];
        this.spuData = {};
        this.level = {};
        this.skuActivity = {};
        this.activityNames = [];
        this.attrData = {};
        this.attrMap = {};
        this.isOpen = false;
        this.clickAttrs = [];
        this.discountData = {};
        this.notAllSelect = false;
        this.nonExistentLevel = false;
    }
    // 限时折扣
    get limit_buy() {
        return Object.keys(this.skuActivity).length &&
            this.skuActivity[this.level.id] &&
            this.skuActivity[this.level.id].activity_type === 'limit_buy'
            ? this.skuActivity[this.level.id]
            : {};
    }
    get salePrice() {
        let price = '¥' + this.level.sale_price;
        if (this.level.giftsActivity &&
            this.level.giftsActivity.gift &&
            !this.limit_buy.id &&
            _.isEmpty(_.intersection(['limit_buy', 'channel'], this.activityNames))) {
            // 无其他有更改价格活动时 使用赠品活动改价功能
            price = '¥' + this.level.giftsActivity.activity_price;
        }
        if (this.level.channel_activity) {
            return '¥' + this.level.activityPrice;
        }
        if (this.level.id) {
            return price;
        }
        return this.limit_buy.id
            ? this.limit_buy.sale_price
            : this.spuData.sale_price;
    }
    get giftsFilter() {
        return this.gifts.filter(i => i.is_show_gift);
    }
    get gifts() {
        if (this.level.giftsActivity &&
            this.level.giftsActivity.gift &&
            _.isEmpty(_.intersection(['channel'], this.activityNames))) {
            return this.level.giftsActivity.gift || [];
        }
        else {
            return this.level.gifts || [];
        }
    }
    get hasVirtualGift() {
        return skuInfo => {
            return (skuInfo &&
                skuInfo.giftsActivity &&
                skuInfo.giftsActivity.gift &&
                skuInfo.giftsActivity.gift.some(el => el.type !== 'physical'));
        };
    }
    get levelClick() {
        if (!this.level.id && this.nonExistentLevel) {
            return {
                canClick: false,
                btnName: '缺货',
            };
        }
        else if (!this.level.id) {
            return {
                canClick: false,
            };
        }
        else if (this.level.state !== 'published') {
            return {
                canClick: false,
                btnName: '已下架',
            };
        }
        else if (this.level.virtual_inventory_qty < 1) {
            return {
                canClick: false,
                btnName: '已售罄',
            };
        }
        else if (this.hasVirtualGift(this.level)) {
            return {
                canClick: false,
                message: '此商品暂不支持添加购物车',
            };
        }
        else if (this.level.channel_activity) {
            return {
                canClick: false,
                btnName: '已售罄',
            };
        }
        else if (this.skuActivity[this.level.id] &&
            this.skuActivity[this.level.id].activity_type !== 'limit_buy') {
            return {
                canClick: false,
                message: '此商品暂不支持添加购物车',
            };
        }
        else {
            return {
                canClick: true,
            };
        }
    }
    async created() {
        await this.initData();
        await this.initAttr();
        this.show = true;
    }
    async initAttr() {
        let _clickAttrs = {};
        Object.keys(this.attrData).forEach(v => {
            _clickAttrs[v] = '';
        });
        if (this.level.id) {
            let clickedIds = [];
            Object.keys(this.attrMap).forEach(key => {
                if (this.attrMap[key].id === this.level.id) {
                    clickedIds = key.split('-');
                }
            });
            let attrsArray = Object.keys(this.attrData).reduce((sum, cur) => {
                return [...sum, ...this.attrData[cur]];
            }, []);
            attrsArray.forEach(v => {
                if (clickedIds.indexOf(v.attr_value_id + '') !== -1) {
                    _clickAttrs[v.attr_name] = v.attr_value_id;
                }
            });
        }
        this.clickAttrs = _clickAttrs;
    }
    async initData() {
        const { data: spuInfo } = await this.$axios.get('/api/goods/shop/search/goods/getSpu', {
            params: {
                spuId: this.cartLevelInfo.spu_id,
                show_unpublish_sku: 1,
            },
        });
        this.spuInfo = spuInfo || {};
        this.skus = spuInfo.skus || [];
        this.attrData = spuInfo.attrs || {};
        this.attrMap = spuInfo.attr_value_ids_sku_map || {};
        this.spuData = this.formatSpu(spuInfo.skus, spuInfo.spu) || {};
        this.level = this.skus.find(el => el.id === this.cartLevelInfo.sku_id);
        this.level._num = 1;
        const { data: { skuActivity }, } = await this.$axios.get('/api/goods/shop/search/goods/discountActivity', {
            params: {
                spuId: this.cartLevelInfo.spu_id,
                skuIds: this.skus.map(i => i.id),
                type: this.spuData.scope,
            },
        });
        this.skuActivity = skuActivity;
        this.activityNames = Array.from(new Set(Object.values(skuActivity)
            .map(i => i['activity_type'])
            .concat(this.level.channel_activity ? ['channel'] : [])));
    }
    async levelHandle(key, item) {
        this.clickAttrs[key] !== item.attr_value_id
            ? (this.clickAttrs[key] = item.attr_value_id)
            : (this.clickAttrs[key] = '');
        let allClicked = true;
        let ids = [];
        Object.keys(this.clickAttrs).forEach(k => {
            ids.push(this.clickAttrs[k]);
            if (!this.clickAttrs[k]) {
                allClicked = false;
            }
        });
        if (!allClicked) {
            this.level = { _num: 1 };
            this.notAllSelect = true;
            this.nonExistentLevel = false;
            return;
        }
        this.notAllSelect = false;
        ids = ids.sort();
        let idsTemp = ids.join('-');
        if (!Object.keys(this.attrMap)
            .map(r => r
            .split('-')
            .sort()
            .join('-'))
            .includes(idsTemp)) {
            // 如果该组合不存在，不操作
            this.level = { _num: 1 };
            this.nonExistentLevel = true;
            return;
        }
        this.nonExistentLevel = false;
        this.level = this.skus.find(v => v.id === this.attrMap[ids.join('-')].id);
        this.level ? (this.level._num = 1) : '';
        let skuId = this.level ? this.level.id : '';
        this.discountData = this.skuActivity[skuId] || {};
    }
    getIsSellout(item) {
        let skuInfo = this.skus.find(el => el.id === item.sku_id);
        if (!skuInfo)
            return true;
        return skuInfo.virtual_inventory_qty <= 0;
    }
    formatSpu(skus, spu) {
        // 计算售价区间
        let _sps = skus.map(v1 => (v1.channel_activity && v1.activityPrice) || v1.sale_price);
        let _ops = skus.map(v2 => v2.origin_price);
        let max = Reflect.apply(Math.max, null, _sps);
        let min = Reflect.apply(Math.min, null, _sps);
        if (max <= min) {
            spu.sale_price =
                ('¥' + skus[0].channel_activity && skus[0].activityPrice) ||
                    '¥' + skus[0].sale_price ||
                    0;
            spu.origin_price = '¥' + skus[0].origin_price || 0;
        }
        else {
            let orMin = Reflect.apply(Math.min, null, _ops);
            spu.sale_price = '¥' + min + '-' + max;
            spu.origin_price = `¥${orMin}-${Reflect.apply(Math.max, null, _ops)}`;
        }
        return spu;
    }
    changeAttrs() {
        if (!this.levelClick.canClick) {
            return this.levelClick.message ? this.$Toast(this.levelClick.message) : '';
        }
        this.$emit('changeAttrs', this.level);
        this.$emit('update:isCartLevelShow', false);
    }
    showGifts() {
        this.isOpen = !this.isOpen;
    }
    changeNum(type) {
        if (this.notAllSelect || (!this.level.id && !this.nonExistentLevel)) {
            this.$Toast('至少选择1件商品');
        }
        else if (type === 'add') {
            this.level._num >= 200
                ? this.$Toast('不能再加啦，商品最多添加200件')
                : this.level._num++;
        }
        else if (type === 'sub') {
            this.level._num <= 1
                ? this.$Toast('不能再减啦，最少购买1件哦～')
                : this.level._num--;
        }
        this.$forceUpdate();
    }
    hide() {
        this.$emit('update:isCartLevelShow', false);
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], CartLevel.prototype, "isCartLevelShow", void 0);
tslib_1.__decorate([
    Prop()
], CartLevel.prototype, "cartLevelInfo", void 0);
CartLevel = tslib_1.__decorate([
    Component
], CartLevel);
export default CartLevel;
